import { isNil } from 'lodash';
import { useMemo } from 'react';
import { useChannelList } from '@shared/util/hooks';

export interface WorkspaceDetail {
  baseNavigationPath: string;
  id: number;
  name: string;
  imageUrl: string;
}

export function useWorkspaceDetails() {
  const { channels } = useChannelList();
  return useMemo(() => {
    const workspaceDetails = new Map<string, WorkspaceDetail>();
    channels.forEach(channel => {
      if (!isNil(channel) && !isNil(channel.workflowTemplateId)) {
        workspaceDetails.set(channel.workflowTemplateId, {
          baseNavigationPath: channel.slug,
          id: channel.id,
          name: channel.name,
          imageUrl: channel.imageUrl ?? '',
        });
      }
    });
    return workspaceDetails;
  }, [channels]);
}
